<template>
  <c-loader
    v-if="disabledSaved"
    class="new-calculation-loader"
    label="Производится сохранение"
    :active="disabledSaved "
    :height="500"
  />
  <div v-else class="production">
    <m-table-settings
      v-model="tableSettingsModal"
      :columns="tableData.columns"
      :disabled-columns="tableData.disabledColumns"
      :default-disabled-columns="tableData.defaultDisabledColumns"
      with-grouped
      @submit="submitTableSettings"
    />
    <m-production-posts
      :active="isShowModalProductionsPosts"
      :posts="postsLocal"
      :table-records="tableData.records"
      @submitPosts="submitPosts"
      @close="isShowModalProductionsPosts = false"
    />
    <m-production-add-workers
      modal-title="Добавить сотрудников"
      :active="isShowModalProductionsAddWorkers"
      :workers="productionAddWorkersModalItems"
      :selected="productionAddWorkersModalItemsSelected"
      :is-calc-first-load="isCalcFirstLoad"
      :table-records="tableData.records"
      :tab="tab"
      :data="data"
      :group-code="productionAddWorkersModalGroupCode"
      @submitWorkers="submitWorkers"
      @close="isShowModalProductionsAddWorkers = false"
    />
    <m-production-add-workers-all
      :active="isShowModalProductionsAddWorkersAll"
      :workers="productionAddWorkersAllModalItems"
      :selected="productionAddWorkersAllModalItemsSelected"
      :posts="postsLocal"
      :tab="tab"
      :table-records="tableData.records"
      :data="data"
      @submitWorkers="submitWorkers"
      @close="isShowModalProductionsAddWorkersAll = false"
    />
    <m-production-write-fine-premium
      :calculation-type="tab"
      :calc-data="data"
      :table-records="tableData.records"
      :active="isShowModalProductionWriteFinePremium"
      @writeFineBonusAllWorkers="writeFineBonusAllWorkers"
      @close="isShowModalProductionWriteFinePremium = false"
    />
    <m-production-create-worker
      modal-title="Создать сотрудника"
      :active="isShowModalProductionCreateWorker"
      :calculation-type="tab"
      :data="data"
      @close="isShowModalProductionCreateWorker = false"
      @createNewWorker="createNewWorker"
    />

    <m-position-intervals ref="positionIntervalsModal"></m-position-intervals>

    <div class="production-header">
      <div class="production-header-buttons-left">
        <c-button-dropdown
          class="production-header-buttons-left-employee"
          :class="{
            'production-header-buttons-left-employee-disabled': dataIsLoading || !canEdit,
          }"
          :disabled="dataIsLoading || !canEdit"
          icon="arrow"
          type="dropdown"
          label="Сотрудники"
          :dropdown="{
            position: 'right',
            items: [
              { label: 'Добавить сотрудников', emit: 'addWorkers' },
              { label: 'Новый сотрудник', emit: 'createWorker' },
              { label: 'Добавить всех', emit: 'addWorkersAll' },
            ],
          }"
          @addWorkers="openAddWorkersAllModal"
          @addWorkersAll="addWorkersAll"
          @createWorker="openCreateWorkerModal"
        />
        <c-button
          class="production-header-buttons-left-post"
          label="Должности"
          :disabled="dataIsLoading || !canEdit"
          color="white"
          size="small"
          @click="isShowModalProductionsPosts = true"
        />
        <c-button
          class="production-header-buttons-left-fine-rewarding"
          :label="tab === 'byPeriod' ? 'Штраф/премия' : 'Штраф/премия смене'"
          :disabled="!isThereWorkersInTable || dataIsLoading || !canEdit"
          color="white"
          size="small"
          @click="isShowModalProductionWriteFinePremium = true"
        />
        <c-select
          v-if="$route.query.calc_id"
          v-model="currentCalcVersion"
          class="production-header-buttons-left-fine-rewarding production-header-select"
          type="select"
          placeholder="Версия расчета"
          :items="getCalcVersions"
        />
      </div>
      <div class="production-header-buttons-right">
        <c-button
          responsive
          size="small"
          :disabled="dataIsLoading || !canEdit"
          label="Настроить столбцы"
          icon="cog"
          type="with-icon"
          @click="openColumnSettingsModalClick()"
        />
        <c-button
          class="production-header-buttons-right-less"
          label="Меньше информации"
          :disabled="dataIsLoading || currentColumnLevel === 1"
          icon="less"
          color="white"
          size="small"
          @click="lessInformation"
        />
        <c-button
          class="production-header-buttons-right-more"
          label="Больше информации"
          icon="more"
          :disabled="dataIsLoading || currentColumnLevel === 3"
          color="white"
          size="small"
          @click="moreInformation"
        />
      </div>
    </div>
    <c-data-table-create-calculations-production
      v-if="!dataIsLoading"
      ref="table"
      class="production-table"
      :levels="1"
      :disabled-columns="tableData.disabledColumns"
      :is-filial-admin="isFilialAdmin"
      :data="tableData"
      :calculation-data="data"
      :calculate-type="tab"
      :personal-reasons="personalReasons"
      :user-columns="productionColumns"
      :premium-personal-account-loading="premiumPersonalAccountLoading"
      :loading-item="loadingItem"
      :bonusesForExceeded="bonusesForExceeded"
      :can-edit="canEdit"
      @productionRemoveWorkerFromCalc="removeWorker"
      @showModalAddWorkers="showModalAddWorkers"
      @showPositionIntervalsModal="showPositionIntervalsModal"
      @updateKPItable="updateKPItable"
      @updateFines="updateFines"
      @updateRank="updateRank"
      @updateCompensation="updateCompensation"
      @updateBonuses="updateBonuses"
      @updatePersonal="updatePersonal"
    />

    <div v-if="!dataIsLoading && (canEdit || canClose || isClosed)" class="production-actions-row">
      <c-button
        v-if="canClose"
        size="large"
        class="production-actions-row__toggle-closed"
        :class="{ 'production-actions-row__toggle-closed--active': !isClosed }"
        :disabled="isTogglingClosed"
        :label="isClosed ? 'Открыть расчёт' : 'Закрыть расчёт'"
        :color="isClosed ? 'primary' : undefined"
        @click="$emit('toggleClosed')"
      />
      <span
        v-if="isClosed"
        class="production-actions-row__closed-badge"
      >Расчёт закрыт</span>
      <responsive-apply-reset-actions
        v-if="canEdit"
        class="production-actions"
        :class="{ 'no-shadow': !displayActionShadows }"
        :disable-submit="disabledSaved"
        @on-submit="saveCalculation"
        @on-reset="cancelCalculation"
      />
    </div>

    <c-loader
      v-if="dataIsLoading"
      class="production-loader"
      label="Данные загружаются"
      :active="dataIsLoading"
      height="300"
    />
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Loader from "@/components/loader";
import ButtonDropdown from "@/components/controls/button-dropdown";
import Button from "@/components/controls2/Button";
import DataTableCreateCalculationProduction from "@/pages/calculations/create/additions/data-table-create-calculation-production";
import ModalProductionPosts from "@/pages/calculations/create/additions/modal-production-posts";
import ModalProductionAddWorkers from "@/pages/calculations/create/additions/modal-production-add-workers";
import ModalProductionAddWorkersAll from "@/pages/calculations/create/additions/modal-production-add-workers-all";

import ModalProdactionWriteFinePremium from "@/pages/calculations/create/additions/modal-production-write-fine-premium";
import ModalProdactionCreateWorker from "@/pages/calculations/create/additions/modal-production-create-worker";

import TableSettingsModal from "@/pages/calculations/create/additions/data-table-create-calculations-settings";
import Select from "@/components/controls2/Select";

import PositionIntervalsSidesheet from "@/pages/calculations/create/additions/position-intervals-sidesheet";
import {
  eventAddWorkerProduction,
  eventRemoveWorkerProduction,
  eventUpdateFinesProduction,
  eventUpdateBonusesProduction,
  eventChangeIntervalsProduction,
  eventAddBonusFineAll,
  eventUpdatePersonalProduction,
  isAdmin,
  isCook,
  recalcTableProduction,
  isProductionRankWithoutFixedSalary,
  eventChangeSalmon, eventChangeLoad,
  findPostProduction, addReasonSurcharge, addWorkerAllButton, eventChangeCategory, eventRemovePostProduction
} from "@/entities/models/calculations";

import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions.vue";
import {onScrollEnd} from "@/helpers/events";

export default {
  name: "new-calculation-production",
  components: {
    ResponsiveApplyResetActions,
    "c-button": Button,
    "c-button-dropdown": ButtonDropdown,
    "c-data-table-create-calculations-production": DataTableCreateCalculationProduction,
    "m-table-settings": TableSettingsModal,
    "m-production-posts": ModalProductionPosts,
    "m-production-add-workers": ModalProductionAddWorkers,
    "m-production-add-workers-all": ModalProductionAddWorkersAll,
    "m-production-write-fine-premium": ModalProdactionWriteFinePremium,
    "m-production-create-worker": ModalProdactionCreateWorker,
    "m-position-intervals": PositionIntervalsSidesheet,
    "c-loader": Loader,
    "c-select": Select,
  },
  props: ["data", "tab", "chapter", "personalReasons", "driversColumns", "productionColumns", "productionColumnsDisabled", "canEdit", "disabledSaved", "changeCalc", "filialLocalValue", "isClosed", "canClose", "isTogglingClosed"],
  data() {
    return {
      premiumPersonalAccountLoading: false,
      isThereWorkersInTable: false,
      dataIsLoading: true,
      isCalcFirstLoad: true,
      isShowModalProductionsPosts: false,
      isShowModalProductionsAddWorkers: false,
      isShowModalProductionsAddWorkersAll: false,
      isShowModalProductionCreateWorker: false,
      productionAddWorkersModalItems: [],
      productionAddWorkersAllModalItems: [],
      productionAddWorkersAllModalItemsSelected: [],
      productionAddWorkersModalItemsSelected: [],
      productionAddWorkersModalGroupCode: "",
      isShowModalProductionWriteFinePremium: false,
      postsLocal: [],
      tableSettingsModal: false,
      tableData: {
        type: "new-calculation-production",
        columns: [],
        allColumns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        disabledColumns: [],
        defaultDisabledColumns: [],
        filteredColumns: [],
        activeFilteredColumns: [],
      },
      bonusesForExceeded: [],
      isFilialAdmin: true,
      currentColumnLevel: 3,
      columnsLevels: {
        1: {
          disabledColumns: [
            "working_interval",
            "amount_working_time",
            "premium_personal_account",
            "personal_account_transactions",
            "rank",
            "compensation",
            "release_from_load",
            "load",
            "salary",
            "main_part_salary",
            "revenue_standard_hour",
            "ratio_standart",
            "revenue_standard",
            "bonus_rate",
            "deprivation_coefficient",
            "corrected_time",
            "premium_for_exceeding_standard",
            "depreciation",
            "prize",
            "fine",
          ],
        },
        2: {
          disabledColumns: [
            "amount_working_time",
            "release_from_load",
            "load",
            "salary",
            "revenue_standard_hour",
            "ratio_standart",
            "revenue_standard",
            "bonus_rate",
            "deprivation_coefficient",
            "corrected_time",
          ],
        },
        3: {
          disabledColumns: [],
        },
      },
      displayActionShadows: true,
      loadingItem: [],
      updateTimeout: null,
      isUpdateTableDataCalled: false,
      calcVersions: null,
      currentCalcVersion: null,
    };
  },
  computed: {
    ...mapGetters("calculations", ["getTableProductionsCreateCalculation", "getTableProductionsByPeriod"]),
    getCalcVersions() {
      if (this.data && this.calcVersions) {
        return this.calcVersions.map(version => ({
          ...version,
          value: version.version_id,
          // label: version.author,
          label: 'Версия расчета', // https://lookin.atlassian.net/browse/HRMS-3856
          formatLabel: `
            <div style="display: flex; align-items: center;">
              <div style="width: 34px; height: 34px; border-radius: 50%; background-color: #8e9cbb; margin-right: 10px; overflow: hidden; flex: 0 0 34px">
                <img src="${(version && version.worker && version.worker.photo) ? version.worker.photo : 'redesign/img/userpic.svg'}" style="width: 100%; height: 100%; object-fit: cover;" />
              </div>
              <div>
                <div style="">${version.author}</div>
                <div style="color: #8E9CBB; font-size: 13px;">${version.date}</div>
              </div>
            </div>
          `,
        }))
      } else {
        return []
      }
    }
  },

  watch: {

    currentCalcVersion: {
      handler(value) {
        this.$store.dispatch('calculations/getCalculationVersion', {
          calcId: this.$route.query.calc_id,
          versionId: value.version_id
        }).then((res) => {
          // console.log(res)
          this.changeCalc(res);
        });
      },
      deep: true
    },

    "tableData.records": {
      deep: true,
      handler(value) {
        let countWorkersInTable = 0;
        value.forEach((postGroup) => {
          if (postGroup.groupName !== "total") {
            postGroup.records.forEach(() => {
              countWorkersInTable += 1;
            });
          }
        });
        this.isThereWorkersInTable = countWorkersInTable > 0;

        // пересчет тотала премий за превышение нормы с учетом премий полученных через бэк, простите за эту жесть
        const premii_premium_for_exceeding_standard = [];
        if (value.length >= 0) {
          value.forEach((r) => {
            if('code' in r && r.records && r.records.length > 0) {
              r.records.forEach((item) => {
                if (this.bonusesForExceeded.find(bonus => bonus.worker_id === item.id) && this.bonusesForExceeded.find(bonus => bonus.worker_id === item.id).bonus) {
                  premii_premium_for_exceeding_standard.push(this.bonusesForExceeded.find(bonus => bonus.worker_id === item.id).bonus);
                } else {
                  premii_premium_for_exceeding_standard.push(item.premium_for_exceeding_standard.value);
                }
              });
            }
          });
        }
        const sum_premii_premium_for_exceeding_standard = premii_premium_for_exceeding_standard.reduce((acc, curr) => acc + curr, 0);

        if (sum_premii_premium_for_exceeding_standard &&
          this.tableData.records.find(record => record.groupName === 'total') && this.tableData.records.find(record => record.groupName === 'total').records &&
          this.tableData.records.find(record => record.groupName === 'total').records.length > 0) {

          this.tableData.records.find(record => record.groupName === 'total').records[0].premium_for_exceeding_standard.value = sum_premii_premium_for_exceeding_standard;
        }
      },
    },
    /*"data.calc_versions": {
      deep: true,
      handler(value) {
        console.log('value', value);
      },
    },*/

    "chapter": function () {
      // this.collectCalculation();
    },
    "data": function (value) {
      this.isDataLoading = true;
      this.isFilialAdmin = value.is_filial_admin;
      this.tableData.records = [];

      if (this.tab === "byDate") {
        this.tableData.disabledColumns = [...this.getTableProductionsCreateCalculation.columns.filter((item) => !this.productionColumns || !this.productionColumns.includes(item.id)).map(s=>s.id)];
        this.tableData.columns = [...this.getTableProductionsCreateCalculation.columns];
        this.tableData.records = [...this.getTableProductionsCreateCalculation.records];
      } else {
        this.tableData.disabledColumns = [...this.getTableProductionsByPeriod.columns.filter((item) => !this.productionColumns || !this.productionColumns.includes(item.id)).map(s=>s.id)];
        this.tableData.columns = [...this.getTableProductionsByPeriod.columns];
        this.tableData.records = [...this.getTableProductionsByPeriod.records];
      }

      let calcWorkers = [];

      if (this.tab === "byDate") {
        calcWorkers = value.calc.production.workers;
      } else {
        calcWorkers = value.period.production.workers;
      }

      this.postsLocal = value.posts.filter((post) => {
        const c = calcWorkers.findIndex((worker) => worker.post_code === post.code);
        if (c !== -1) {
          this.tableData.records.unshift({
            code: post.code,
            groupName: post.name,
            records: [],
          });
          return true;
        }
        let isTrue = false;

        Object.keys(this.data.production).forEach((key) => {
          if (isTrue) {
            return;
          }
          const postCode = key.split("-")[1];
          if (postCode === post.code) {
            isTrue = true;
          }
        });

        return isTrue;
      });

      if (this.tab === "byDate") {
        this.reinitRecordsByDate();
      } else {
        calcWorkers.forEach((worker) => {
          const findGroupIndex = this.tableData.records.findIndex((group) => group.code === worker.post_code);
          const defaultPersonalHistory = [
            {
              type: worker.personal > 0 ? "+" : "-",
              amount: Math.abs(Math.round(worker.personal)),
              authorName: "vpadmin",
              comment: null,
              reason: null,
              reason_id: null,
            },
          ];
          if (findGroupIndex !== -1) {

            let findReferenceDataWorker = this.data.production[`${worker.worker_id}-${worker.post_code}`];
            if (!findReferenceDataWorker)
              findReferenceDataWorker = Object.values(this.data.production).find((w) => w.id==worker.worker_id);
            if (findReferenceDataWorker !== undefined) {
              this.tableData.records[findGroupIndex].records.push({
                codeGroup: worker.post_code,
                id: worker.worker_id,
                categoryId: worker.category_id,
                categoryNumber: worker.category_number,
                worktime: worker.worktime,
                sum_compens: worker.sum_compens,
                sum_deposit: worker.sum_deposit,
                sum_surcharge: worker.sum_surcharge,
                personalAmount: findReferenceDataWorker.personal_amount,
                employee: {
                  value: worker.showname,
                },
                doc_problem: findReferenceDataWorker.doc_problem,
                recommened_category: findReferenceDataWorker.recommened_category,
                premium_personal_account: {
                  value: `${Math.round(
                    findReferenceDataWorker.personal_amount*100,
                  )/100}`,
                },
                sum_deposit: {
                  value: Math.round(worker.sum_deposit),
                },

                personal_account_balance: {
                  value: Math.round(worker.personal*100)/100,
                },
                count_smenas: {
                  value: worker.count_smenas,
                },
                period_working_time: {
                  value: this.convertHoursToHHMM(worker.worktime),
                },
                period_rank: {
                  value: worker.category_number,
                },
                period_compensation: {
                  value: worker.sum_compens,
                },
                load: {
                  value: Math.round(worker.count_products),
                },
                salary: {
                  value: Math.round(worker.s_salary),
                },
                main_part_salary: {
                  value: Math.round(worker.sum_salary),
                },
                revenue_standard_hour: {
                  value: Math.round(this.getRevenueStandardHour(worker.post_code)),
                },
                ratio_standart: {
                  value: worker.s_koutput,
                },
                revenue_standard: {
                  value: Math.round(worker.normday),
                },
                bonus_rate: {
                  value: worker.s_kbonus,
                },
                deprivation_coefficient: {
                  value: worker.s_kpenaly,
                },
                corrected_time: {
                  value: this.convertHoursToHHMM(worker.worktime_correctly),
                },
                premium_for_exceeding_standard: {
                  value: Math.round(worker.sum_bonus_calc),
                },
                depreciation: {
                  value: Math.round(worker.sum_penalty_calc),
                },
                prize: {
                  value: worker.sum_bonus,
                  items: worker.bonuses,
                },
                fine: {
                  value: worker.sum_penalty,
                  items: worker.fines,
                },

                personal_account_transactions: {
                  value: Math.round(worker.personal),
                  items:
                    worker.personal_history && worker.personal_history.length > 0
                      ? worker.personal_history
                      : defaultPersonalHistory,
                },
                account_accrued: Math.round(worker.plus*100)/100,
                account_removed: Math.round(worker.minus*100)/100,
                account_balance: Math.round(worker.personal*100)/100,

                personal_account_accrued: {
                  value: Math.round(worker.plus*100)/100,
                },
                personal_account_removed: {
                  value: Math.round(worker.minus*100)/100,
                },
                balance: {
                  value: Math.round(worker.balance*100)/100,
                },

                total_accrued: {
                  value: Math.round(worker.plus*100)/100,
                },
                already_paid: {
                  value: Math.round(worker.minus*100)/100 * -1,
                },
                to_payoff: {
                  value: Math.round(worker.balance*100)/100 // -Math.round(worker.personal)  //Math.round(worker.sum_paid),
                },
                confidence_level: worker.confidence_level,
                correction_type: worker.correction_type,
                isShowRow: true,
              });
            } else {
              this.tableData.records[findGroupIndex].records.push({
                codeGroup: worker.post_code,
                id: worker.worker_id,
                categoryId: worker.category_id,
                categoryNumber: worker.category_number,
                worktime: worker.worktime,
                sum_compens: worker.sum_compens,
                sum_deposit: worker.sum_deposit,
                sum_surcharge: worker.sum_surcharge,
                personalAmount: 0,
                employee: {
                  value: worker.showname,
                },
                doc_problem: 0,
                recommened_category: 0,
                premium_personal_account: {
                  value: `${0}`,
                },

                sum_deposit: {
                  value: Math.round(worker.sum_deposit),
                },

                personal_account_balance: {
                  value: Math.round(worker.personal*100)/100,
                },
                count_smenas: {
                  value: worker.count_smenas,
                },
                period_working_time: {
                  value: this.convertHoursToHHMM(worker.worktime),
                },
                period_rank: {
                  value: worker.category_number,
                },
                period_compensation: {
                  value: worker.sum_compens,
                },
                load: {
                  value: Math.round(worker.count_products),
                },
                salary: {
                  value: Math.round(worker.s_salary),
                },
                main_part_salary: {
                  value: Math.round(worker.sum_salary),
                },
                revenue_standard_hour: {
                  value: Math.round(this.getRevenueStandardHour(worker.post_code)),
                },
                ratio_standart: {
                  value: worker.s_koutput,
                },
                revenue_standard: {
                  value: Math.round(worker.normday),
                },
                bonus_rate: {
                  value: worker.s_kbonus,
                },
                deprivation_coefficient: {
                  value: worker.s_kpenaly,
                },
                corrected_time: {
                  value: this.convertHoursToHHMM(worker.worktime_correctly),
                },
                premium_for_exceeding_standard: {
                  value: Math.round(worker.sum_bonus_calc),
                },
                depreciation: {
                  value: Math.round(worker.sum_penalty_calc),
                },
                prize: {
                  value: worker.sum_bonus,
                  items: worker.bonuses,
                },
                fine: {
                  value: worker.sum_penalty,
                  items: worker.fines,
                },

                personal_account_transactions: {
                  value: Math.round(worker.personal),
                  items:
                    worker.personal_history && worker.personal_history.length > 0
                      ? worker.personal_history
                      : defaultPersonalHistory,
                },

                account_accrued: Math.round(worker.plus*100)/100,
                account_removed: Math.round(worker.minus*100)/100,
                account_balance: Math.round(worker.personal*100)/100,
                plus: Math.round(worker.plus*100)/100,
                minus: Math.round(worker.minus*100)/100,
                personal_account_accrued: {
                  value: Math.round(worker.plus*100)/100,
                },
                personal_account_removed: {
                  value: Math.round(worker.minus*100)/100,
                },
                balance: {
                  value: typeof worker.balance==='object' ? worker.balance.value : Math.round(worker.balance*100)/100,
                },
                total_accrued: {
                  value: Math.round(worker.plus*100)/100,
                },
                already_paid: {
                  value: Math.round(worker.minus*100)/100 * -1,
                },
                to_payoff: {
                  value: Math.round(worker.balance*100)/100, // -Math.round(worker.personal)  //Math.round(worker.sum_paid),
                },
                confidence_level: worker.confidence_level,
                correction_type: worker.correction_type,
                isShowRow: true,
              });
            }
          }
        });

        this.tableData.records.map((g)=>{
          g.records.map((w)=>{
            // let worker = w;

            let sumFines = 0; let sumPrizes = 0;
            if (!w.prize.items) w.prize.items = [];
            w.prize.items.forEach((item) => {
              if (!item.is_external) sumPrizes += Number(item.amount);
            });
            if (!w.fine.items) w.fine.items = [];
            w.fine.items.forEach((item) => {
              if (!item.is_external) sumFines += Number(item.amount);
            });

            let minus = 0; let plus = 0;
            if (w.personal_account_transactions.items) {
              w.personal_account_transactions.items.map((t)=>{
                if (t.type=="-") minus+=Number(t.amount); else plus+=Number(t.amount);
              });
            }
            w.personal_account_transactions.value = Math.round((plus-minus)*100)/100;
            w.total_accrued.value = Math.round((Number(w.account_accrued) + plus + sumPrizes)*100)/100;
            w.already_paid.value = Math.round((Number(w.account_removed) + minus + sumFines)*100)/100;
            w.to_payoff.value = Math.round((Number(w.balance.value) + plus - minus + sumPrizes - sumFines)*100)/100;
            w.personal_account_balance.value = Math.round(w.premium_personal_account.value*100)/100;
            w.personal_account_balance_start = w.premium_personal_account.value - plus + minus - sumPrizes + sumFines;
          });
        });

        setTimeout(() => {
          this.updateKPItable();
        }, 300);

        this.calculateTotalRow();

        this.sortProductionTable();
      }
      this.loadAllWorkerBonuses();
      this.dataIsLoading = false;

      // console.log('111-->', this.getTableProductionsCreateCalculation);
      // console.log('222222-->', this.tableData);

      // if(this.tableData.records.length>0){
      //   this.tableData.records.find(r => r.groupName==='total').records[0].premium_for_exceeding_standard.value = 232323
      //   console.log('---->', this.tableData.records.find(r => r.groupName==='total').records[0].premium_for_exceeding_standard.value);
      // }
    },

    "tableData.disabledColumns": function (value) {
      this.$emit("disabledColumnsEvent", {c:value, t:"production"});

      if (value.length === 0) {
        this.currentColumnLevel = 3;
      }
      if (
        value === this.columnsLevels[2].disabledColumns ||
        (value.length !== 0 && value.length < this.columnsLevels[2].disabledColumns.length)
      ) {
        this.currentColumnLevel = 2;
      }
      if (
        value === this.columnsLevels[1].disabledColumns ||
        value.length >= this.columnsLevels[1].disabledColumns.length
      ) {
        this.currentColumnLevel = 1;
      }
    },
  },

  async created() {
    this.tableData.disabledColumns=this.productionColumnsDisabled;
  },

  mounted() {
    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", this.handleScroll);

    if (this.$route.query.calc_id) {
      this.getCalculationVersions();
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.displayActionShadows = true;

      onScrollEnd(async () => {
        this.displayActionShadows = false;
      });
    },

    openColumnSettingsModalClick() {
      if (this.tab === "byPeriod") {
        this.tableData.columns = [...this.getTableProductionsByPeriod.columns];
      } else {
        this.tableData.columns = [...this.getTableProductionsCreateCalculation.columns];
      }
      this.tableSettingsModal = true;
    },

    addWorkersAll() {
      addWorkerAllButton(this.data);
      this.reinitRecordsByDate();
    },

    salmon(v) {
      eventChangeSalmon(v, this.data);
      this.reinitRecordsByDate();
    },

    loadvalue(v) {
      eventChangeLoad(v.v, v.code, this.data);
      this.reinitRecordsByDate();
    },

    reinitRecordsByDate() {
      const currentPosts = JSON.parse(JSON.stringify(this.tableData.records)).map((p) => p.code);
      this.tableData.records = [...this.getTableProductionsCreateCalculation.records];

      this.postsLocal = this.data.posts.filter((post) => {
        const c = this.data.calc.production.workers.findIndex((worker) => worker.post_code === post.code);
        const c1 = currentPosts.findIndex((code) => code === post.code);
        if (c !== -1 || c1 !== -1) {
          this.tableData.records.unshift({
            code: post.code,
            groupName: post.name,
            position: post.position,
            records: [],
          });
          return true;
        }
        let isTrue = false;

        Object.keys(this.data.production).forEach((key) => {
          if (isTrue) {
            return;
          }
          const postCode = key.split("-")[1];
          if (postCode === post.code) {
            isTrue = true;
          }
        });

        return isTrue;
      });

      const hasNoPostWorkers = this.data.calc.production.workers.some((worker) => worker.post_code === 'no_post' || worker.is_no_post);
      if (hasNoPostWorkers) {
        const noPostGroupExists = this.tableData.records.some((group) => group.code === 'no_post');
        if (!noPostGroupExists) {
          this.tableData.records.unshift({
            code: 'no_post',
            groupName: 'Без должности',
            position: 999999,
            records: [],
          });
        }
      }

      this.data.calc.production.workers.forEach((worker) => {
        let personalAmount = 0;

        if (!worker.select_id) {
          worker.select_id = `${worker.worker_id}-${worker.post_code}`;
        }

        if (worker.select_id in this.data.production) {
          const w = this.data.production[worker.select_id];
          // console.log(999, personalAmount, w.personal_amount, w.personal_amount_calc, worker.worker_id, this.data.production);
          personalAmount = "personal_amount_calc" in w ? w.personal_amount_calc : w.personal_amount;
          personalAmount = Math.round(personalAmount);
        }

        const post = findPostProduction(worker.post_code, this.data.calc);
        const defaultPersonalHistory = [
          {
            type: worker.personal > 0 ? "+" : "-",
            amount: Math.abs(Math.round(worker.personal)),
            authorName: "vpadmin",
            comment: null,
            reason: null,
            reason_id: null,
          },
        ];

        const normalizedPostCode = (!worker.post_code || worker.is_no_post) ? 'no_post' : worker.post_code;
        const findGroupIndex = this.tableData.records.findIndex((group) => group.code === normalizedPostCode);

        if (findGroupIndex !== -1) {
          const findReferenceDataWorker = this.data.production[`${worker.worker_id}-${worker.post_code}`];

          if (findReferenceDataWorker !== undefined) {
            this.tableData.records[findGroupIndex].records.push({
              codeGroup: normalizedPostCode,
              id: worker.worker_id,
              sum_deposit: {
                value: worker.sum_deposit ? worker.sum_deposit : null,
              },
              employee: {
                value: worker.showname,
              },
              doc_problem: worker.doc_problem,
              recommened_category: findReferenceDataWorker.recommened_category,
              premium_personal_account: {
                value: personalAmount, // `${findReferenceDataWorker.personal_amount}`,
              },
              personal_account_transactions: {
                value: -worker.personal,
                items:
                  worker.personal_history && worker.personal_history.length > 0
                    ? worker.personal_history
                    : defaultPersonalHistory,
              },
              rank: {
                value: worker.category_id,
              },
              working_interval: {
                value: worker.intervals,
              },
              amount_working_time: {
                value: this.convertHoursToHHMM(worker.worktime),
              },
              compensation: {
                value: post && post.s_worktime_compens && worker.worktime < post.s_worktime_compens ?
                  worker.sum_compens :
                  '',
                is_need: post && post.s_worktime_compens && post.s_worktime_compens,
                id: worker.reason_surcharge_id,
              },
              release_from_load: {
                value: "",
              },
              load: {
                value: worker.count_products,
              },
              salary: {
                value: worker.s_salary,
              },
              main_part_salary: {
                value: Math.round(worker.sum_salary),
              },
              revenue_standard_hour: {
                value: Math.round(this.getRevenueStandardHour(worker.post_code)),
              },
              ratio_standart: {
                value: worker.s_koutput,
              },
              revenue_standard: {
                value: Math.round(worker.normday),
              },
              bonus_rate: {
                value: worker.s_kbonus,
              },
              deprivation_coefficient: {
                value: worker.s_kpenaly,
              },
              corrected_time: {
                value: this.convertHoursToHHMM(worker.worktime_correctly),
              },
              premium_for_exceeding_standard: {
                value: Math.round(worker.sum_bonus_calc),
              },
              depreciation: {
                value: Math.round(worker.sum_penalty_calc),
              },
              prize: {
                value: worker.sum_bonus,
                items: worker.bonuses,
              },
              fine: {
                value: worker.sum_penalty,
                items: worker.fines,
              },
              total_accrued: {
                value: Math.round(worker.sum),
              },
              to_payoff: {
                value: Math.round(worker.sum_paid * 100) / 100,
              },
              confidence_level: worker.confidence_level,
              correction_type: worker.correction_type,
              isShowRow: true,
            });
          } else {
            this.tableData.records[findGroupIndex].records.push({
              codeGroup: normalizedPostCode,
              id: worker.worker_id,
              employee: {
                value: worker.showname,
              },
              sum_deposit: {
                value: worker.sum_deposit ? worker.sum_deposit : null,
              },
              doc_problem: worker.doc_problem,
              recommened_category: 0,
              premium_personal_account: {
                value: personalAmount,
              },
              personal_account_transactions: {
                value: -worker.personal,
                items:
                  worker.personal_history && worker.personal_history.length > 0
                    ? worker.personal_history
                    : defaultPersonalHistory,

              },
              rank: {
                value: worker.category_number,
              },
              working_interval: {
                value: worker.intervals,
              },
              amount_working_time: {
                value: this.getAmountWorkerTime(worker.intervals),
              },
              compensation: {
                value: post && post.s_worktime_compens && worker.worktime < post.s_worktime_compens ?
                  worker.sum_compens :
                  '',
                is_need: post && post.s_worktime_compens && post.s_worktime_compens,
                id: worker.reason_surcharge_id,
              },
              release_from_load: {
                value: "",
              },
              load: {
                value: worker.count_products,
              },
              salary: {
                value: worker.s_salary,
              },
              main_part_salary: {
                value: isProductionRankWithoutFixedSalary(worker.category_number)
                  ? 0
                  : Math.round((worker.s_salary / 12) * this.sumHoursWorked),
              },
              revenue_standard_hour: {
                value: Math.round(this.getRevenueStandardHour(worker.post_code)),
              },
              ratio_standart: {
                value: worker.s_koutput,
              },
              revenue_standard: {
                value: Math.round(worker.normday),
              },
              bonus_rate: {
                value: worker.s_kbonus,
              },
              deprivation_coefficient: {
                value: worker.s_kpenaly,
              },
              corrected_time: {
                value: this.convertHoursToHHMM(worker.worktime_correctly),
              },
              premium_for_exceeding_standard: {
                value: Math.round(worker.sum_bonus_calc),
              },
              depreciation: {
                value: Math.round(worker.sum_penalty_calc),
              },
              prize: {
                value: worker.sum_bonus,
                items: worker.bonuses,
              },
              fine: {
                value: worker.sum_penalty,
                items: worker.fines,
              },
              total_accrued: {
                value: Math.round(worker.sum),
              },
              to_payoff: {
                value: Math.round(worker.sum_paid * 100) / 100,
              },
              confidence_level: worker.confidence_level,
              correction_type: worker.correction_type,
              isShowRow: true,
            });
          }
        }
      });
      // console.log(this.tableData.records);
      // this.calculateTotalRow();
      this.sortProductionTable();
      this.updateKPItable();

    },

    sortProductionTable() {

      this.tableData.records.sort((a, b) => {

        if (a.groupName === "total") {
          return 1;
        }
        if (b.groupName === "total") {
          return -1;
        }
        if (a.groupName && b.groupName) {
          const as = `${a.position ? 10000 - a.position : 9999}#${a.groupName}`;
          const bs = `${b.position ? 10000 - b.position : 9999}#${b.groupName}`;
          return -as.localeCompare(bs);
        }
        return 1;
      });
    },

    timeToDecimal(t) {
      const arr = t.split(":");
      const dec = parseInt((arr[1] / 6) * 10, 10);
      return parseFloat(`${parseInt(arr[0], 10)}.${dec < 10 ? "0" : ""}${dec}`);
    },

    updateKPItable() {
      this.calculateTotalRow();

      if (this.tab === "byPeriod") {
        const items = [];
        this.tableData.records.forEach((group) => {
          if (group.groupName !== "total") {
            items.push({
              code: group.code,
              employees: group.records.length,
              toPayoff: group.records.reduce(
                (sumToPayoff, record) => sumToPayoff + record.personal_account_accrued.value, 0),
            });
          }
        });

        this.$emit("updateKPItable", items);
      }
    },

    lessInformation() {
      if (this.currentColumnLevel > 1) {
        this.currentColumnLevel -= 1;
        this.tableData.disabledColumns = [...this.columnsLevels[this.currentColumnLevel].disabledColumns];
        if (this.$refs.table) {
          this.$refs.table.scroll(1, true);
          // this.$refs.table.scrollTo(0, 0);
        }
      }
    },

    moreInformation() {
      if (this.currentColumnLevel < 3) {
        this.currentColumnLevel += 1;
        this.tableData.disabledColumns = [...this.columnsLevels[this.currentColumnLevel].disabledColumns];
        if (this.$refs.table) this.$refs.table.scroll(1, true);
      }
    },

    calculateTotalRow() {
      if (this.tab === "byDate") {
        const findTotalGroupIndex = this.tableData.records.findIndex((group) => group.groupName === "total");
        let countWorkersAll = 0;
        if (findTotalGroupIndex !== -1) {
          this.tableData.records[findTotalGroupIndex].records[0].amount_working_time.value = "00:00";
          this.tableData.records[findTotalGroupIndex].records[0].revenue_standard.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].deprivation_coefficient.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].corrected_time.value = "00:00";
          this.tableData.records[findTotalGroupIndex].records[0].premium_for_exceeding_standard.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].depreciation.value = 0;

          this.tableData.records[findTotalGroupIndex].records[0].total_accrued.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].to_payoff.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].sum_deposit.value = 0;

        }

        this.tableData.records.forEach((group) => {
          if (group.groupName !== "total") {
            group.records.forEach((record) => {
              countWorkersAll += 1;
              this.tableData.records[findTotalGroupIndex].records[0].amount_working_time.value = this.sumTime(
                this.tableData.records[findTotalGroupIndex].records[0].amount_working_time.value,
                record.amount_working_time.value,
              );

              this.tableData.records[findTotalGroupIndex].records[0].deprivation_coefficient.value +=
                record.deprivation_coefficient.value;
              this.tableData.records[findTotalGroupIndex].records[0].corrected_time.value = this.sumTime(
                this.tableData.records[findTotalGroupIndex].records[0].corrected_time.value,
                record.corrected_time.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].premium_for_exceeding_standard.value += record.premium_for_exceeding_standard.value;
              this.tableData.records[findTotalGroupIndex].records[0].depreciation.value += record.depreciation.value;

              this.tableData.records[findTotalGroupIndex].records[0].total_accrued.value += record.total_accrued.value;
              this.tableData.records[findTotalGroupIndex].records[0].to_payoff.value += record.to_payoff.value;
              this.tableData.records[findTotalGroupIndex].records[0].sum_deposit.value += record.sum_deposit.value;
            });
          }
        });

        let v = parseFloat(this.data.calc.production.s_koutput);
        this.tableData.records[findTotalGroupIndex].records[0].ratio_standart.value = v ? v.toFixed(2) : 0;
        v = parseFloat(this.data.calc.production.s_kbonus);
        this.tableData.records[findTotalGroupIndex].records[0].bonus_rate.value = v ? v.toFixed(2) : 0;
        this.tableData.records[findTotalGroupIndex].records[0].total_accrued.value = Math.round(
          this.data.calc.production.sum);
        this.tableData.records[findTotalGroupIndex].records[0].prize.value = Math.round(
          this.data.calc.production.sum_bonus);
        this.tableData.records[findTotalGroupIndex].records[0].fine.value = Math.round(
          this.data.calc.production.sum_penalty);
        this.tableData.records[findTotalGroupIndex].records[0].main_part_salary.value = Math.round(
          this.data.calc.production.sum_salary);
        const deprivationCoefficient = this.tableData.records[findTotalGroupIndex].records[0].deprivation_coefficient.value;
        this.tableData.records[findTotalGroupIndex].records[0].deprivation_coefficient.value =
          this.tableData.records[findTotalGroupIndex].records[0].deprivation_coefficient.value !== 0
            ? (deprivationCoefficient / countWorkersAll).toFixed(2)
            : 0;
      } else {
        const findTotalGroupIndex = this.tableData.records.findIndex((group) => group.groupName === "total");
        let countWorkersAll = 0;

        // console.log('total prod');
        if (findTotalGroupIndex !== -1) {
          this.tableData.records[findTotalGroupIndex].records[0].period_working_time.value = "00:00";
          this.tableData.records[findTotalGroupIndex].records[0].main_part_salary.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].ratio_standart.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].revenue_standard.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].bonus_rate.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].corrected_time.value = "00:00";
          this.tableData.records[findTotalGroupIndex].records[0].premium_for_exceeding_standard.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].total_accrued.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].to_payoff.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].already_paid.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].balance.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].sum_deposit.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].depreciation.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].prize.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].fine.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].personal_account_accrued.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].personal_account_removed.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].balance.value = 0;
          this.tableData.records[findTotalGroupIndex].records[0].personal_account_transactions.value = 0;

        }

        this.tableData.records.forEach((group) => {
          if (group.groupName !== "total") {
            group.records.forEach((record) => {
              countWorkersAll += 1;
              this.tableData.records[findTotalGroupIndex].records[0].period_working_time.value = this.sumTime(
                this.tableData.records[findTotalGroupIndex].records[0].period_working_time.value,
                record.period_working_time.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].main_part_salary.value +=
                record.main_part_salary.value;
              this.tableData.records[findTotalGroupIndex].records[0].ratio_standart.value += Number(
                record.ratio_standart.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].revenue_standard.value +=
                record.revenue_standard.value;
              this.tableData.records[findTotalGroupIndex].records[0].bonus_rate.value += Number(
                record.bonus_rate.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].corrected_time.value = this.sumTime(
                this.tableData.records[findTotalGroupIndex].records[0].corrected_time.value,
                record.corrected_time.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].sum_deposit.value += Number(
                record.sum_deposit.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].depreciation.value += Number(
                record.depreciation.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].prize.value += Number(
                record.prize.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].fine.value += Number(
                record.fine.value,
              );
              this.tableData.records[findTotalGroupIndex].records[0].premium_for_exceeding_standard.value +=
                record.premium_for_exceeding_standard.value;
              this.tableData.records[findTotalGroupIndex].records[0].total_accrued.value += record.total_accrued.value;
              this.tableData.records[findTotalGroupIndex].records[0].to_payoff.value += record.to_payoff.value;
              this.tableData.records[findTotalGroupIndex].records[0].already_paid.value += Number(
                record.already_paid.value);
              this.tableData.records[findTotalGroupIndex].records[0].personal_account_accrued.value += Number(
                record.personal_account_accrued.value);
              this.tableData.records[findTotalGroupIndex].records[0].personal_account_removed.value += Number(
                record.personal_account_removed.value);
              this.tableData.records[findTotalGroupIndex].records[0].balance.value += Number(record.balance.value);
              this.tableData.records[findTotalGroupIndex].records[0].personal_account_transactions.value += Number(
                record.personal_account_transactions.value);
            });
          }
        });

        this.tableData.records[findTotalGroupIndex].records[0].total_accrued.value = Math.round(
          this.tableData.records[findTotalGroupIndex].records[0].total_accrued.value * 100) / 100;
        this.tableData.records[findTotalGroupIndex].records[0].to_payoff.value = Math.round(
          this.tableData.records[findTotalGroupIndex].records[0].to_payoff.value * 100) / 100;
        this.tableData.records[findTotalGroupIndex].records[0].already_paid.value = Math.round(
          this.tableData.records[findTotalGroupIndex].records[0].already_paid.value * 100) / 100;
        this.tableData.records[findTotalGroupIndex].records[0].personal_account_accrued.value = Math.round(
          this.tableData.records[findTotalGroupIndex].records[0].personal_account_accrued.value * 100) / 100;
        this.tableData.records[findTotalGroupIndex].records[0].personal_account_removed.value = Math.round(
          this.tableData.records[findTotalGroupIndex].records[0].personal_account_removed.value * 100) / 100;
        this.tableData.records[findTotalGroupIndex].records[0].balance.value = Math.round(
          this.tableData.records[findTotalGroupIndex].records[0].balance.value * 100) / 100;
        this.tableData.records[findTotalGroupIndex].records[0].personal_account_transactions.value = Math.round(
          this.tableData.records[findTotalGroupIndex].records[0].personal_account_transactions.value * 100) / 100;

        this.tableData.records[findTotalGroupIndex].records[0].ratio_standart.value =
          this.tableData.records[findTotalGroupIndex].records[0].ratio_standart.value !== 0
            ? (this.tableData.records[findTotalGroupIndex].records[0].ratio_standart.value / countWorkersAll).toFixed(2)
            : 0;
        this.tableData.records[findTotalGroupIndex].records[0].bonus_rate.value =
          this.tableData.records[findTotalGroupIndex].records[0].bonus_rate.value !== 0
            ? (this.tableData.records[findTotalGroupIndex].records[0].bonus_rate.value / countWorkersAll).toFixed(2)
            : 0;
      }
    },

    recountPersonalPeriod(record) {
      let minus = 0;
      let plus = 0;
      record.personal_account_transactions.items.forEach((item) => {
        if (item.type == '+') {
          plus += Number(item.amount);
        } else {
          minus += Number(item.amount);
        }
      });

      let sumFines = 0;
      let sumPrizes = 0;
      record.prize.items.forEach((item) => {
        // console.log('prize', item);
        if (!item.is_external) sumPrizes += Number(item.amount);
      });
      record.fine.items.forEach((item) => {
        // console.log('fine', item);
        if (!item.is_external) sumFines += Number(item.amount);
      });

      record.to_payoff.value = Number(record.balance.value) + plus - minus + sumPrizes - sumFines; // к выплате
      record.total_accrued.value = Number(record.personal_account_accrued.value) + plus + sumPrizes; // всего начислено
      record.already_paid.value = Number(record.personal_account_removed.value) + minus + sumFines; // всего списано
      record.personal_account_balance.value = record.personal_account_balance_start + plus - minus + sumPrizes -
        sumFines;
      ;// - minus + sumPrizes - sumFines; остаток на лс

      // record.personal_account_balance.value = record.personal_account_balance_start + plus - minus + sumPrizes - sumFines; ;// - minus + sumPrizes - sumFines; остаток на лс

      // record.personal_account_balance.value  = record.personal_account_balance_start

      record.to_payoff.value = Math.round(record.to_payoff.value * 100) / 100;
      record.total_accrued.value = Math.round(record.total_accrued.value * 100) / 100;
      record.already_paid.value = Math.round(record.already_paid.value * 100) / 100;
      record.personal_account_balance.value = Math.round(record.personal_account_balance.value * 100) / 100;

      this.updateKPItable();
    },

    updateFines(params) {
      if (this.tab === "byPeriod") {
        this.recountPersonalPeriod(params.record);

      } else {

        const w = params.record;
        eventUpdateFinesProduction(w.id, w.codeGroup, w.fine.items, this.data);
        this.reinitRecordsByDate();
      }
    },

    updateRank(params) {
      if (this.tab === "byPeriod") {
      } else {
        const w = params.record;
        eventChangeCategory(w.id, w.codeGroup, params.id, this.data);
        this.reinitRecordsByDate();
      }
    },

    updateCompensation(params) {
      if (this.tab === "byPeriod") {
      } else {
        const w = params.record;
        addReasonSurcharge(w.id, w.codeGroup, params.id, params.value, this.data);
        this.reinitRecordsByDate();
      }
    },

    updatePersonal(params) {
      if (this.tab === "byPeriod") {
      } else {
        const w = params.record;
        eventUpdatePersonalProduction(w.id, w.codeGroup, w.personal_account_transactions.items, this.data);
        this.reinitRecordsByDate();
      }
    },

    updateBonuses(params) {
      if (this.tab === "byPeriod") {
        this.recountPersonalPeriod(params.record);
      } else {
        const w = params.record;
        eventUpdateBonusesProduction(w.id, w.codeGroup, w.prize.items, this.data);
        this.reinitRecordsByDate();
      }
    },

    changeIntervals(w, i) {
      if (this.tab === "byPeriod") {
      } else {
        eventChangeIntervalsProduction(w.id, w.codeGroup, i, this.data);
        this.reinitRecordsByDate();

        if (!this.isUpdateTableDataCalled) {
          this.isUpdateTableDataCalled = true;

          // this.updateTableData(w);
          this.loadAllWorkerBonuses();

          //без него вызов происходит два раза
          setTimeout(() => {
            this.isUpdateTableDataCalled = false;
          }, 0);
        }
      }
    },

    removeWorker(worker) {
      const workerId = worker.id;
      if (this.tab === "byPeriod") {
        this.tableData.records.forEach((group) => {
          const c = group.records.findIndex((record) => record.id === workerId);
          if (c !== -1) {
            group.records.splice(c, 1);
          }
        });
        this.updateKPItable();
      } else {
        this.tableData.records.forEach((group) => {
          const c = group.records.findIndex((record) => record.id === workerId);
          if (c !== -1) {
            eventRemoveWorkerProduction(workerId, worker.codeGroup, this.data);
          }
        });
        this.reinitRecordsByDate();
      }

    },

    submitWorkers(params) {

      if (params !== null && params !== undefined) {
        if (this.tab !== "byPeriod") {
          const {codeGroup} = params;

          params.selected.map((key) => {
            const index = this.data.calc.production.workers.findIndex((w) => `${w.worker_id}-${w.post_code}` == key);
            if (index == -1) {
              eventAddWorkerProduction(key, this.data);
            }
          });

          this.data.calc.production.workers.map((w) => {
            if (!codeGroup || codeGroup == w.post_code) {
              const index = params.selected.findIndex((key) => `${w.worker_id}-${w.post_code}` == key);
              if (index == -1) {
                eventRemoveWorkerProduction(w.worker_id, w.post_code, this.data);
              }

            }
          });
          this.reinitRecordsByDate();

          return;
        }
        const {codeGroup} = params;
        const {workers} = params;
        if (codeGroup) {
          workers.map((w) => w.codeGroup = codeGroup);
        }

        workers.forEach((worker) => {
          const {codeGroup} = worker;

          let c = this.tableData.records.findIndex((group) => group.code === codeGroup);

          if (c === -1 && codeGroup) {
            const findIndexPost = this.data.posts.findIndex((post) => post.code === codeGroup);
            this.tableData.records.unshift({
              code: codeGroup,
              groupName: this.data.posts[findIndexPost].name,
              records: [],
            });
            c = this.tableData.records.findIndex((group) => group.code === codeGroup);
          }

          if (c != -1) {
            const findIndexRecord = this.tableData.records[c].records.findIndex((record) => record.id === worker.id);
            if (this.tab === "byDate") {
              if (findIndexRecord !== -1 && !worker.isActive) {
                this.tableData.records[c].records.splice(findIndexRecord, 1);
              } else if (findIndexRecord === -1 && worker.isActive) {
                this.tableData.records[c].records.push({
                  codeGroup,
                  id: worker.id,
                  employee: {
                    value: worker.name,
                  },
                  doc_problem: worker.doc_problem,
                  recommened_category: worker.recommened_category,
                  premium_personal_account: {
                    value: worker.premium_personal_account,
                  },
                  personal_account_transactions: {
                    value: worker.personal_account_transactions,
                  },
                  rank: {
                    value: worker.rank,
                  },
                  working_interval: {
                    value: worker.intervals,
                  },
                  amount_working_time: {
                    value: worker.amount_working_time,
                  },
                  compensation: {
                    value: worker.compensation,
                  },
                  release_from_load: {
                    value: "",
                  },
                  load: {
                    value: worker.load,
                  },
                  salary: {
                    value: worker.salary,
                  },
                  main_part_salary: {
                    value: worker.main_part_salary,
                  },
                  revenue_standard_hour: {
                    value: worker.revenue_standard_hour,
                  },
                  ratio_standart: {
                    value: worker.ratio_standart,
                  },
                  revenue_standard: {
                    value: Math.round(worker.revenue_standard),
                  },
                  bonus_rate: {
                    value: worker.bonus_rate,
                  },
                  deprivation_coefficient: {
                    value: worker.deprivation_coefficient,
                  },
                  corrected_time: {
                    value: worker.corrected_time === 0 ? "00:00" : worker.corrected_time,
                  },
                  premium_for_exceeding_standard: {
                    value: worker.premium_for_exceeding_standard,
                  },
                  depreciation: {
                    value: worker.depreciation,
                  },
                  prize: {
                    value: worker.prize,
                    items: worker.prizeItems,
                  },
                  fine: {
                    value: worker.fine,
                    items: worker.fineItems,
                  },
                  total_accrued: {
                    value: worker.total_accrued,
                  },
                  to_payoff: {
                    value: worker.to_payoff,
                  },
                  confidence_level: worker.confidence_level,
                  correction_type: worker.correction_type,
                  isShowRow: true,
                });
              }
              this.$emit("updateKPItable", {
                countWorkers: params.workers.reduce((a, b) => {
                  if (b.isActive) a += 1;
                  return a;
                }, 0),
                codeGroup,
              });
            } else {
              if (findIndexRecord !== -1 && !worker.isActive) {
                this.tableData.records[c].records.splice(findIndexRecord, 1);
              } else if (findIndexRecord === -1 && worker.isActive) {
                // console.log('!!!', worker);
                this.tableData.records[c].records.push({
                  codeGroup: worker.codeGroup,
                  id: worker.id,
                  employee: {
                    value: worker.name,
                  },
                  categoryId: worker.category_id,
                  categoryNumber: worker.category_number,
                  sum_compens: worker.sum_compens === undefined || worker.sum_compens === null ? 0 : worker.sum_compens,
                  sum_deposit: worker.sum_deposit === undefined || worker.sum_deposit === null ? 0 : worker.sum_deposit,
                  sum_surcharge:
                    worker.sum_surcharge === undefined || worker.sum_surcharge === null ? 0 : worker.sum_surcharge,
                  worktime: worker.worktime,
                  personalAmount: worker.personalAmount,
                  doc_problem: worker.doc_problem,
                  recommened_category: worker.recommened_category,
                  premium_personal_account: {
                    value: worker.premium_personal_account.value,
                  },
                  account_accrued: Math.round(worker.sum * 100) / 100,
                  account_removed: Math.round(worker.sum_prepay * 100) / 100,
                  account_balance: Math.round(worker.personal * 100) / 100,

                  personal_account_transactions: {
                    value: Math.round(worker.personal_account_transactions.value * 100) / 100,
                    items: [],
                  },
                  personal_account_accrued: {
                    value: worker.personal_account_transactions.value,
                  },
                  personal_account_removed: {
                    value: Math.round(worker.personal_account_removed.value * 100) / 100,
                  },
                  personal_account_balance: {
                    value: Math.round(worker.personal_account_balance.value * 100) / 100,
                  },
                  count_smenas: {
                    value: worker.count_smenas.value,
                  },
                  balance: {
                    value: "balance" in worker ? worker.balance.value : 0,
                  },
                  sum_deposit: {
                    value: "sum_deposit" in worker ? worker.sum_deposit.value : 0,
                  },
                  period_working_time: {
                    value: worker.period_working_time.value,
                  },
                  period_rank: {
                    value: worker.period_rank.value,
                  },
                  period_compensation: {
                    value: worker.period_compensation.value,
                  },
                  load: {
                    value: worker.load.value,
                  },
                  salary: {
                    value: worker.salary.value,
                  },
                  main_part_salary: {
                    value: worker.main_part_salary.value,
                  },
                  revenue_standard_hour: {
                    value: worker.revenue_standard_hour.value,
                  },
                  ratio_standart: {
                    value: worker.ratio_standart.value,
                  },
                  revenue_standard: {
                    value: worker.revenue_standard.value,
                  },
                  bonus_rate: {
                    value: worker.bonus_rate.value,
                  },
                  deprivation_coefficient: {
                    value: worker.deprivation_coefficient.value,
                  },
                  corrected_time: {
                    value: worker.corrected_time.value,
                  },
                  premium_for_exceeding_standard: {
                    value: worker.premium_for_exceeding_standard.value,
                  },
                  depreciation: {
                    value: worker.depreciation.value,
                  },
                  prize: {
                    value: worker.prize.value,
                    items: worker.prize.items,
                  },
                  fine: {
                    value: worker.fine.value,
                    items: worker.fine.items,
                  },
                  total_accrued: {
                    value: worker.total_accrued.value,
                  },
                  already_paid: {
                    value: worker.already_paid.value,
                  },
                  to_payoff: {
                    value: worker.to_payoff.value,
                  },
                  confidence_level: worker.confidence_level,
                  correction_type: worker.correction_type,
                  isShowRow: true,
                });
              }
              setTimeout(() => {
                this.updateKPItable();
              }, 300);
            }
          }
        });
        // }
        // Обновляем модальное окно должности
        this.postsLocal = JSON.parse(JSON.stringify(this.postsLocal));

        this.calculateTotalRow();
        this.sortProductionTable();
      }
    },

    createNewWorker(worker) {
      if (this.tab === "byDate") {
        eventAddWorkerProduction(worker.key, this.data);
        this.reinitRecordsByDate();
        return;

      }

      let c = this.tableData.records.findIndex((group) => group.code === worker.post_code);

      if (c === -1) {
        const findIndexPost = this.data.posts.findIndex((post) => post.code === worker.post_code);
        this.tableData.records.unshift({
          code: worker.post_code,
          groupName: this.data.posts[findIndexPost].name,
          records: [],
        });
        c = this.tableData.records.findIndex((group) => group.code === worker.post_code);
      }

      const defaultPersonalHistory = [
        {
          type: worker.personal > 0 ? "+" : "-",
          amount: Math.abs(Math.round(worker.personal)),
          authorName: "vpadmin",
          comment: null,
          reason: null,
          reason_id: null,
        },
      ];

      if (c !== -1) {
        if (this.tab === "byDate") {
          //
        } else {
          this.tableData.records[c].records.push({
            codeGroup: worker.post_code,
            id: worker.worker_id,
            categoryId: worker.category_id,
            categoryNumber: worker.category_number,
            worktime: worker.worktime,
            sum_compens: worker.sum_compens,
            sum_deposit: worker.sum_deposit,
            sum_surcharge: worker.sum_surcharge,
            personalAmount: 0,
            employee: {
              value: worker.showname,
            },
            doc_problem: "Не добавлены обязательные документы",
            recommened_category: 0,
            premium_personal_account: {
              value: `${Math.round(0)}`,
            },
            account_accrued: Math.round(worker.sum * 100) / 100,
            account_removed: Math.round(worker.sum_prepay * 100) / 100,
            account_balance: Math.round(worker.personal * 100) / 100,

            personal_account_transactions: {
              value: Math.round(worker.personal),
              items:
                worker.personal_history && worker.personal_history.length > 0
                  ? worker.personal_history
                  : defaultPersonalHistory,
            },
            personal_account_accrued: {
              value: Math.round(worker.sum * 100) / 100,
            },
            personal_account_removed: {
              value: Math.round(worker.sum_prepay * 100) / 100,
            },
            balance: {
              value: Math.round(worker.balance * 100) / 100,
            },
            sum_deposit: {
              value: Math.round(worker.sum_deposit * 100) / 100,
            },

            personal_account_balance: {
              value: 0,
            },
            count_smenas: {
              value: worker.count_smenas,
            },
            period_working_time: {
              value: this.convertHoursToHHMM(worker.worktime),
            },
            period_rank: {
              value: worker.category_number,
            },
            period_compensation: {
              value: worker.sum_compens,
            },
            load: {
              value: Math.round(worker.count_products),
            },
            salary: {
              value: Math.round(worker.s_salary),
            },
            main_part_salary: {
              value: Math.round(worker.sum_salary),
            },
            revenue_standard_hour: {
              value: Math.round(this.getRevenueStandardHour(worker.post_code)),
            },
            ratio_standart: {
              value: worker.s_koutput === null ? "0" : worker.s_koutput,
            },
            revenue_standard: {
              value: Math.round(worker.normday),
            },
            bonus_rate: {
              value: worker.s_kbonus === null ? "0" : worker.s_kbonus,
            },
            deprivation_coefficient: {
              value: worker.s_kpenaly === null ? "0" : worker.s_kpenaly,
            },
            corrected_time: {
              value: this.convertHoursToHHMM(worker.worktime_correctly),
            },
            premium_for_exceeding_standard: {
              value: Math.round(worker.sum_bonus_calc * 100) / 100,
            },
            depreciation: {
              value: Math.round(worker.sum_penalty_calc * 100) / 100,
            },
            prize: {
              value: worker.sum_bonus,
              items: worker.bonuses,
            },
            fine: {
              value: worker.sum_penalty,
              items: worker.fines,
            },
            total_accrued: {
              value: Math.round(worker.sum * 100) / 100,
            },
            already_paid: {
              value: Math.round(worker.sum_prepay * 100) / 100 * -1,
            },
            to_payoff: {
              value: Math.round(worker.sum_paid * 100) / 100,
            },
            confidence_level: worker.confidence_level,
            correction_type: worker.correction_type,
            isShowRow: true,
          });
          setTimeout(() => {
            this.updateKPItable();
          }, 300);
        }
      }
      // Обновляем модальное окно должности
      this.postsLocal = JSON.parse(JSON.stringify(this.postsLocal));
      this.calculateTotalRow();
      this.sortProductionTable();
    },

    submitPosts(posts) {
      posts.forEach((post) => {
        const c = this.tableData.records.findIndex((postGroup) => postGroup.code === post.code);
        if (c !== -1 && !post.isActive) {
          if (this.tab === "byDate") {
            eventRemovePostProduction(post.code, this.data);
          }
          this.tableData.records.splice(c, 1);
          this.reinitRecordsByDate();
        }
        if (c === -1 && post.isActive) {
          this.tableData.records.unshift({
            code: post.code,
            groupName: post.name,
            records: [],
          });
        }
      });

      this.calculateTotalRow();
      this.$emit("sendActivePosts", posts);
      this.sortProductionTable();

      setTimeout(() => {
        this.updateKPItable();
      }, 300);
    },

    submitTableSettings(columns) {
      if (columns.length === 0) {
        this.tableData.disabledColumns = [];
      }
      if (this.$refs.table) this.$refs.table.scroll();
    },

    sumTime(t1, t2) {
      let hh1 = 0;
      let mm1 = 0;
      let hh2 = 0;
      let mm2 = 0;

      let resultHH = 0;
      let resultMM = 0;
      if (t1 === 0) {
        hh1 = 0;
        mm2 = 0;
      } else if (typeof t1 !== "number") {
        hh1 = Number(t1.split(":")[0]);
        mm1 = Number(t1.split(":")[1]);
      }

      if (t2 === 0) {
        hh1 = 0;
        mm2 = 0;
      } else if (typeof t1 !== "number") {
        hh2 = Number(t2.split(":")[0]);
        mm2 = Number(t2.split(":")[1]);
      }

      resultHH = hh1 + hh2;
      resultMM = mm1 + mm2;
      if (resultMM > 59) {
        resultMM -= 60;
        resultHH += 1;
      }

      if (resultHH < 10) {
        resultHH = `0${resultHH}`;
      }

      if (resultMM < 10) {
        resultMM = `0${resultMM}`;
      }

      return `${resultHH}:${resultMM}`;
    },

    getAmountWorkerTime(intervals) {
      if (intervals !== undefined) {
        let sumHoursWorked = 0;
        intervals.forEach((interval) => {
          const start = moment(interval.start);
          const end = moment(interval.finish);
          const duration = moment.duration(end.diff(start)).asHours();
          sumHoursWorked += duration;
        });
        this.sumHoursWorked = sumHoursWorked;
        const n = new Date(0, 0);
        n.setSeconds(+sumHoursWorked * 60 * 60);
        return n.toTimeString().slice(0, 5);
      }
      return 0;
    },

    convertHoursToHHMM(decimalTimeString) {
      let decimalTime = parseFloat(decimalTimeString);
      decimalTime = decimalTime * 60 * 60;
      let hours = Math.floor(decimalTime / (60 * 60));
      decimalTime -= hours * 60 * 60;
      let minutes = Math.floor(decimalTime / 60);
      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      return `${hours}:${minutes}`;
    },

    getRevenueStandardHour(groupCode) {
      if (this.tab === "byDate") {
        const c = this.data.calc.production.posts.findIndex((post) => post.post_code === groupCode);
        if (c !== -1) {
          return this.data.calc.production.posts[c].s_norm;
        }
        return 0;
      }

      if (this.tab === "byPeriod") {
        const c = this.data.period.production.posts.findIndex((post) => post.post_code === groupCode);
        if (c !== -1) {
          return this.data.period.production.posts[c].s_norm;
        }
        return 0;
      }
      return 0;
    },

    openCreateWorkerModal() {
      if (!this.canEdit) {
        return;
      }
      this.isShowModalProductionCreateWorker = true;
    },

    showModalAddWorkers(group) {
      if (!this.canEdit) {
        return;
      }
      const groupPostCode = group.code;
      this.productionAddWorkersModalGroupCode = group.code;

      if (this.tab === "byDate") {
        const workersNotIncludedCalc = [];

        Object.entries(this.data.production).forEach(([key, workerData]) => {
          if (workerData.post_code == groupPostCode) {
            const workerId = key.split("-")[0];
            workersNotIncludedCalc.push({
              is_filial: workerData.is_filial,
              key,
              post_code: workerData.post_code,
              showname: workerData.name,
              worker_id: workerId,
            });
          }
        });

        this.productionAddWorkersModalItems = workersNotIncludedCalc;
        this.productionAddWorkersModalItemsSelected = [];
        Object.entries(this.data.calc.production.workers).forEach(([key, w]) => {
          if (w.post_code == groupPostCode) {
            this.productionAddWorkersModalItemsSelected.push(`${w.worker_id}-${w.post_code}`);
          }
        });
      } else {
        let {workers} = this.data.period.production;
        const workersNotIncludedCalc = [];
        Object.entries(this.data.production).forEach(([key, workerData]) => {
          const workerId = key.split("-")[0];
          const c = workers.findIndex((worker) => worker.worker_id.toString() === workerId.toString());
          let skbonus =
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category].s
              ? this.data.settings.production[workerData.post_code].categories[workerData.category].s.k_bonus
              : 0;
          let ssalary =
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category].s
              ? this.data.settings.production[workerData.post_code].categories[workerData.category].s.salary
              : 0;
          let skpenalty =
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category].s
              ? this.data.settings.production[workerData.post_code].categories[workerData.category].s.k_output
              : 0;

          if (ssalary === undefined) ssalary = 0;
          if (skbonus === undefined) skbonus = 0;
          if (skpenalty === undefined) skpenalty = 0;

          let categoryNumber = 0;
          if (
            workerData.category &&
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category]
          ) {
            categoryNumber = this.data.settings.production[workerData.post_code].categories[workerData.category].number;
          }

          if (c === -1) {
            workersNotIncludedCalc.push({
              is_filial: workerData.is_filial,
              bonus_id: 0,
              bonuses: [],
              category_id: workerData.category,
              category_number: categoryNumber,
              count_products: 0,
              count_smenas: 0,
              personalAmount: workerData.personal_amount,
              fine_id: 0,
              fines: [],
              normday: 0,
              personal: 0,
              post_code: workerData.post_code,
              s_kbonus: skbonus,
              s_koutput: skpenalty,
              s_kpenaly: 0,
              s_salary: ssalary,
              showname: workerData.name,
              showpost: workerData.post,
              sum: 0,
              sum_bonus: 0,
              sum_bonus_calc: 0,
              sum_compens: 0,
              sum_deposit: 0,
              sum_paid: 0,
              sum_penalty: 0,
              sum_penalty_calc: 0,
              sum_prepay: 0,
              balance: 0,
              sum_deposit: 0,
              sum_round: 0,
              sum_salary: 0,
              sum_surcharge: 0,
              worker_id: workerId,
              worktime: 0,
              worktime_correctly: 0,
            });
          } else {
            workers[c].is_filial = workerData.is_filial;
          }

        });

        workers = workers.concat(workersNotIncludedCalc);

        this.productionAddWorkersModalItems = workers.filter((worker) => worker.post_code === groupPostCode);
      }

      this.isShowModalProductionsAddWorkers = true;
    },

    showPositionIntervalsModal(position) {
      if (isAdmin(position) && !this.data.aIntervals) recalcTableProduction(this.data);
      if (isCook(position) && !this.data.sIntervals) recalcTableProduction(this.data);

      this.$refs.positionIntervalsModal.open(position, isAdmin(position) ? this.data.aIntervals : this.data.sIntervals);
    },

    openAddWorkersAllModal() {
      if (!this.canEdit) {
        return;
      }
      if (this.tab === "byDate") {
        const workersNotIncludedCalc = [];

        Object.entries(this.data.production).forEach(([key, workerData]) => {
          const workerId = key.split("-")[0];
          workersNotIncludedCalc.push({
            is_filial: workerData.is_filial,
            key,
            post_code: workerData.post_code,
            post: workerData.post,
            showname: workerData.name,
            worker_id: workerId,
            filial_id: workerData.filial_id,
            filial_name: workerData.filial_name,
          });
        });
        this.productionAddWorkersAllModalItems = workersNotIncludedCalc;

        this.productionAddWorkersAllModalItemsSelected = [];

        Object.entries(this.data.calc.production.workers).forEach(([key, w]) => {
          this.productionAddWorkersAllModalItemsSelected.push(`${w.worker_id}-${w.post_code}`);
        });

      } else {
        let {workers} = this.data.period.production;
        const workersNotIncludedCalc = [];

        Object.entries(this.data.production).forEach(([key, workerData]) => {
          // console.log(workers);
          const workerId = key.split("-")[0];
          const c = workers.findIndex((worker) => worker.worker_id.toString() === workerId.toString());
          let skbonus =
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category].s
              ? this.data.settings.production[workerData.post_code].categories[workerData.category].s.k_bonus
              : 0;
          let ssalary =
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category].s
              ? this.data.settings.production[workerData.post_code].categories[workerData.category].s.s_salary
              : 0;
          let skpenalty =
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category].s
              ? this.data.settings.production[workerData.post_code].categories[workerData.category].s.k_output
              : 0;

          if (ssalary === undefined) ssalary = 0;
          if (skbonus === undefined) skbonus = 0;
          if (skpenalty === undefined) skpenalty = 0;

          let categoryNumber = 0;
          if (
            workerData.category &&
            this.data.settings.production[workerData.post_code] &&
            this.data.settings.production[workerData.post_code].categories[workerData.category]
          ) {
            categoryNumber = this.data.settings.production[workerData.post_code].categories[workerData.category].number;
          }

          if (c === -1) {
            // console.log(workerData);
            workersNotIncludedCalc.push({
              is_filial: workerData.is_filial,
              bonus_id: 0,
              bonuses: [],
              category_id: workerData.category,
              category_number: categoryNumber,
              count_products: 0,
              count_smenas: workerData.smenas,
              fine_id: 0,
              fines: [],
              normday: 0,
              personal: 0,
              personal_history: [],
              post_code: workerData.post_code,
              s_kbonus: skbonus,
              s_koutput: skpenalty,
              s_kpenaly: 0,
              s_salary: ssalary,
              showname: workerData.name,
              showpost: workerData.post,
              sum: 0,
              sum_bonus: 0,
              sum_bonus_calc: 0,
              sum_compens: 0,
              sum_deposit: 0,
              sum_paid: 0,
              sum_penalty: 0,
              sum_penalty_calc: 0,
              sum_prepay: 0,
              balance: 0,
              sum_deposit: 0,
              sum_round: 0,
              sum_salary: 0,
              sum_surcharge: 0,
              worker_id: workerId,
              worktime: 0,
              worktime_correctly: 0,
            });
          } else {
            workers[c].is_filial = workerData.is_filial;
          }
        });

        // console.log(workers, workersNotIncludedCalc);
        workers = workers.concat(workersNotIncludedCalc);

        this.productionAddWorkersAllModalItems = JSON.parse(JSON.stringify(workers));
      }

      this.isShowModalProductionsAddWorkersAll = true;
    },

    writeFineBonusAllWorkers(params) {
      // console.log(params);
      if (this.tab !== "byPeriod" && params.basis) {
        eventAddBonusFineAll(
          params.type == "premium" ? "bonus" : "fine",
          params.category.value == "delivery" ? "drivers" : "production",

          {
            amount: parseFloat(params.amount),
            id: null,
            reason_id: params.basis.value,
            reason: params.basis.label,
            author_id: params.author ? params.author.value : null
          },
          this.data
        );
        this.reinitRecordsByDate();
        // console.log(params);
        return;
      }
      this.tableData.records.forEach((group) => {
        group.records.forEach((record) => {
          if (group.groupName !== "total") {
            if (params.type === "fine") {
              record.fine.items.push({
                amount: params.amount,
                author_id: params.author === null ? null : params.author.value,
                reason: params.basis.label,
                comment: params.comment,
                reason_id: params.basis.value,
                is_external: false,
              });
              record.fine.value = Number(record.fine.value) + Number(params.amount);

              /* let sumFines = 0;
              let sumPrizes = 0;
              record.prize.items.forEach((item) => {
                if (!item.is_external) sumPrizes += Number(item.amount);
              });
              record.fine.items.forEach((item) => {
                if (!item.is_external) sumFines += Number(item.amount);
              });
              record.to_payoff.value =
                Number(record.personal_account_transactions.value) + Number(sumPrizes) - Number(sumFines); */
            } else {
              record.prize.items.push({
                amount: params.amount,
                author_id: params.author === null ? null : params.author.value,
                reason: params.basis.label,
                comment: params.comment,
                reason_id: params.basis.value,
                is_external: false,
              });
              record.prize.value = Number(record.prize.value) + Number(params.amount);

              /*
              let sumFines = 0;
              let sumPrizes = 0;
              record.prize.items.forEach((item) => {
                if (!item.is_external) sumPrizes += Number(item.amount);
              });
              record.fine.items.forEach((item) => {
                if (!item.is_external) sumFines += Number(item.amount);
              });
              record.to_payoff.value =
                Number(record.personal_account_transactions.value) + Number(sumPrizes) - Number(sumFines); */
            }
            ;
            this.recountPersonalPeriod(record);
          }
        });
      });

      this.updateKPItable();
    },

    cancelCalculation() {
      this.$emit("cancelCalculation");
    },

    saveCalculation() {
      this.collectCalculation();
      this.$emit("saveCalculation", {callback: this.getCalculationVersions});
    },

    getCalculationVersions() {
      this.$store.dispatch('calculations/getCalculationVersions', this.$route.query.calc_id).then((res) => {
        this.calcVersions = res;
      });
    },

    collectCalculation() {

      if (this.tab === "byPeriod") {
        const workers = [];
        const posts = {};
        const total = {sum: 0, sum_round: 0, sum_paid: 0};

        this.tableData.records.filter((group) => group.records.length > 0 && group.groupName !== "total").map((group) =>
          group.records.forEach((record) => {
            if (!(record.codeGroup in posts)) posts[record.codeGroup] = {sum: 0, sum_round: 0, sum_paid: 0};
            posts[record.codeGroup].sum += record.total_accrued.value;
            posts[record.codeGroup].sum_round += record.total_accrued.value;
            posts[record.codeGroup].sum_paid += -record.personal_account_transactions.value;
            total.sum += record.to_payoff.value;
            total.sum_round += record.to_payoff.value;
            total.sum_paid += -record.personal_account_transactions.value;

            workers.push({
              bonus_id: 0,
              bonuses: record.prize.items.map((item) => ({
                amount: item.amount,
                author_id: item.author_id,
                is_external: item.is_external,
                comment: item.comment,
                reason: item.reason,
                reason_id: item.reason_id,
              })),
              category_id: record.categoryId,
              category_number: record.categoryNumber,
              count_products: record.load.value,
              count_smenas: record.count_smenas.value,
              fine_id: 0,
              fines: record.fine.items.map((item) => item),
              normday: record.revenue_standard.value,
              personal: -record.personal_account_transactions.value,
              personal_history: record.personal_account_transactions.items.map((item) => ({
                type: item.type,
                amount: Number(item.amount),
                comment: item.comment,
                authorName: "vpadmin",
                reason: "",
                reason_id: item.reason_id,
              })),
              post_code: record.codeGroup,
              s_kbonus: record.bonus_rate.value,
              s_koutput: record.ratio_standart.value,
              s_kpenaly: record.deprivation_coefficient.value,
              s_salary: record.salary.value,
              showname: record.employee.value,
              showpost: group.groupName,
              sum: record.personal_account_accrued.value,
              sum_bonus: record.prize.value,
              sum_bonus_calc: record.premium_for_exceeding_standard.value,
              plus: record.account_accrued,
              minus: record.account_removed,
              sum_compens: record.sum_compens,
              sum_deposit: record.sum_deposit,
              sum_surcharge: record.sum_surcharge,

              sum_paid: record.to_payoff.value,
              sum_penalty: record.fine.value,
              sum_penalty_calc: record.depreciation.value,
              sum_prepay: record.personal_account_removed.value,
              balance: record.balance.value,// record.personal_account_accrued.value,
              sum_deposit: record.sum_deposit.value,
              sum_round: Math.round(record.total_accrued.value * 100) / 100,
              sum_salary: record.main_part_salary.value,
              worker_id: record.id,
              worktime: record.worktime,
              worktime_correctly: this.timeToDecimal(record.corrected_time.value),
            });
          }),
        );

        this.data.period.production.workers = workers;
        Object.entries(this.data.period.production).forEach(([key, value]) => {
          if (key !== "workers" && key !== "posts") {
            this.data.period.production[key] = value !== null ? value : 0;
          }
        });
        Object.entries(this.data.period.production.posts).forEach(([key, value]) => {
          if (value.post_code in posts) {
            value.sum = posts[value.post_code].sum.toFixed(2);
            value.sum_round = posts[value.post_code].sum_round.toFixed(2);
            value.sum_paid = posts[value.post_code].sum_paid.toFixed(2);
          } else {
            value.sum = 0;
            value.sum_round = 0;
            value.sum_paid = 0;
          }
        });
        this.data.period.production.sum = total.sum.toFixed(2);
        this.data.period.production.sum_round = total.sum_round.toFixed(2);
        this.data.period.production.sum_paid = total.sum_paid.toFixed(2);
        Object.entries(this.data.period.drivers).forEach(([key, value]) => {
          if (key !== "workers") {
            this.data.period.drivers[key] = value !== null ? value : 0;
          }
        });
      } else {

      }
    },

    async loadAllWorkerBonuses() {
      if (this.data && this.data.calc && this.data.calc.production && this.data.calc.production.crm_sum && this.filialLocalValue && this.filialLocalValue.id) {
        this.premiumPersonalAccountLoading = true;
        const workersData = [];

        this.tableData.records.forEach(r => {
          if('position' in r && 'records' in r) {
            r.records.forEach(record => {
              workersData.push({
                id: record.id,
                post_code: record.codeGroup,
                work_time: record.amount_working_time.value,
                bonus: record.premium_for_exceeding_standard.value
              });
            });
          }
        });

        this.bonusesData = workersData;

        const request = {
          data: {
            sum_amount: this.data.calc.production.crm_sum,
            filial_id: this.filialLocalValue.id,
            workers: workersData
          }
        };

        try {
          const res = await this.$store.dispatch('employees/getWorkersBonuses', request);

          if(res && res.data && res.data.length > 0) {
            this.bonusesForExceeded = res.data;
          }
        }
        catch {
          this.$notify({
            group: "error-message",
            data: {
              textMessage: `Произошла ошибка сохранения премии за превышение нормы. Попробуйте ещё раз.`,
            },
          });
        }
        finally {
          this.premiumPersonalAccountLoading = false;
        }
      }
    },

    //пока оставил на случай доработок
    // async updateTableData(record) {
    //   this.loadingItem.push(record.id);
    //
    //   if (this.updateTimeout) {
    //     clearTimeout(this.updateTimeout);
    //   }
    //
    //   const request = {
    //     data: {
    //       sum_amount: this.data.calc.production.crm_sum,
    //       filial_id: this.filialLocalValue.id,
    //       workers: [
    //         {
    //           id: record.id,
    //           post_code: record.codeGroup,
    //           work_time: record.amount_working_time.value,
    //           bonus: record.premium_for_exceeding_standard.value
    //         },
    //       ]
    //     }
    //   };
    //
    //   try {
    //     const res = await this.$store.dispatch('employees/getWorkersBonuses', request);
    //     console.log('resp2---->', res);
    //     if (res && res.length > 0) {
    //       res.forEach(item => {
    //         const bonusItem = this.bonusesForExceeded.find(bonus => bonus.id === item.worker_id);
    //         if(bonusItem && item.bonus) {
    //           bonusItem.bonus = item.bonus;
    //         }
    //       });
    //     }
    //   }
    //   catch {
    //     this.$notify({
    //       group: "error-message",
    //       data: {
    //         textMessage: `Произошла ошибка сохранения премии за превышение нормы. Попробуйте ещё раз.`,
    //       },
    //     });
    //   }
    //   finally {
    //     this.loadingItem = [];
    //   }
    //
    // }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.production {
  margin-top: 30px;

  &-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    z-index: 2;

    &-select {
      min-width: 200px;

      /deep/ {
        .c-select__wrapper {
          height: 30px;
          border: 1px solid #d3d8df;
          padding: 0 15px;
          border-radius: 15px;
        }

        .c-select__input {
          border: unset;
        }

        .c-select__placeholder {
          font-size: 12px;
          font-weight: 500;
          color: #000;
          top: 47%;
          transform: translateY(-50%);
        }

        .c-select__value {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: 500;
          color: #000;
        }

        .c-select__icon {
          margin-bottom: 4px !important;
        }
      }
    }

    &-buttons-left {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      &-employee {
        &-disabled {
          opacity: 0.5;
          pointer-events: none !important;
        }

        ::v-deep .c-button__dropdown__container__list__item__label {
          white-space: nowrap;
        }
        ::v-deep .c-button__dropdown__container {
          max-width: 210px;
        }
      }

      &-post {
        margin-left: 10px;
      }

      &-fine-rewarding {
        margin-left: 10px;
      }
    }

    &-buttons-right {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      &-less {
        margin-left: 10px;
      }

      &-more {
        margin-left: 10px;
      }
    }
  }

  &-table {
    margin-top: 20px;
    z-index: 1;
  }

  &-loader {
    margin-top: 20px;
  }

  &-actions {
    height: 58px;
    padding: 10px 0 10px 30px;
    position: sticky;
    bottom: -6px;
    right: 0;
    box-shadow: 0 -6px 4px -4px #00000025;
    background-color: #fff;
    transition: all 150ms ease;
    justify-content: flex-end;
    z-index: 70;
    margin-top: 20px;

    &.no-shadow {
      box-shadow: none !important;
    }

    @include onlyStandartMobile {
      width: 100vw;
      position: static;
      height: auto;
      padding: 0;
      box-shadow: none;
    }
  }

  &-actions-row {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 58px;
    padding: 10px 0 10px 30px;
    position: sticky;
    bottom: -6px;
    right: 0;
    box-shadow: 0 -6px 4px -4px #00000025;
    background-color: #fff;
    transition: all 150ms ease;
    justify-content: flex-end;
    z-index: 70;
    margin-top: 20px;

    @include onlyStandartMobile {
      width: 100vw;
      position: static;
      height: auto;
      padding: 0;
      box-shadow: none;
      flex-wrap: wrap;
    }

    &__toggle-closed--active {
      background-color: #fff !important;
      border-color: #f56c6c !important;
      color: #f56c6c !important;

      &:hover {
        border-color: #e04040 !important;
        color: #e04040 !important;
      }
    }

    &__closed-badge {
      display: inline-block;
      padding: 6px 14px;
      border-radius: 4px;
      background-color: #f56c6c;
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      white-space: nowrap;
    }

    .production-actions {
      margin-top: 0;
      position: static;
      box-shadow: none;
      height: auto;
      padding: 0;
      background: none;
    }
  }
}
</style>
